import React from "react";
import { Button, Container } from "reactstrap";
import { useNavigate } from "react-router-dom";
import errorserver from "../../assets/images/errorserver.png";

const ErrorPage = () => {
  const navigate = useNavigate();

  return (
    <Container
      className="d-flex flex-column justify-content-center align-items-center text-center"
      style={{ minHeight: "100vh", padding: "2rem" }}
    >
      <img
        src={errorserver}
        alt="Internal Server Error"
        style={{ maxWidth: "400px", width: "100%" }}
      />
      {/* <h1 className="mt-4 display-4 text-success">Internal Server Error</h1> */}
      <p className="text-muted mt-4">
        Oops! Something went wrong on our end. Please try again later.
      </p>
      <Button color="success" onClick={() => navigate("/")}>
        Go to Home
      </Button>
    </Container>
  );
};

export default ErrorPage;
